module.exports = __webpack_public_path__ + "static/media/RESULT_DETAILS.0481534d.pdf";